import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-resumer-save-dialog-box',
	standalone: true,
	imports: [ReactiveFormsModule, CommonModule],
	templateUrl: './resumer-save-dialog-box.component.html',
	styleUrl: './resumer-save-dialog-box.component.scss'
})
export class ResumerSaveDialogBoxComponent implements OnInit {

	resumeForm!: FormGroup;


	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<ResumerSaveDialogBoxComponent>,
		private toastr: ToastrService
	) {
		this.resumeForm = new FormGroup({
			resume_name: new FormControl('', [Validators.required])
		});
	}


	ngOnInit(): void {
		if (this.data?.resumeName) {
			this.resumeForm.patchValue({
				resume_name: this.data.resumeName
			});
		}
	}


	onCancel() {
		this.dialogRef.close()
	}


	onSave() {
		if (this.resumeForm.invalid) {
			this.resumeForm.markAllAsTouched();
			return;
		}
		this.dialogRef.close(this.resumeForm.value.resume_name);
	}

}
